import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { SmartEditRootModule, SMART_EDIT_FEATURE } from '@spartacus/smartedit/root'

@NgModule({
  declarations: [],
  imports: [SmartEditRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [SMART_EDIT_FEATURE]: {
          module: () => import('@spartacus/smartedit').then(m => m.SmartEditModule)
        }
      }
    } as CmsConfig)
  ]
})
export class SmartEditFeatureModule {}
